"use client";

import { c as _c } from "react/compiler-runtime";
import { FiActivity, FiShield, FiUsers, FiCalendar, FiDollarSign } from "react-icons/fi";
import { HiOutlineLightningBolt } from "react-icons/hi";
import OutlineStar from "@/Components/Common/Icons/OutlineStar";
import RatingStar from "@/Components/Common/Icons/RatingStar";
import { useState } from "react";

// Icon component for rating categories
const CategoryIcon = t0 => {
  const $ = _c(11);
  const {
    icon,
    color
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      efficacy: HiOutlineLightningBolt,
      safety: FiShield,
      tolerability: FiUsers,
      adherence: FiCalendar,
      price: FiDollarSign
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const iconMap = t1;
  const IconComponent = iconMap[icon] || HiOutlineLightningBolt;
  const t2 = `${color}15`;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      backgroundColor: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== color) {
    t4 = {
      color
    };
    $[3] = color;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== IconComponent || $[6] !== t4) {
    t5 = <IconComponent className="w-4 h-4 sm:w-5 sm:h-5" style={t4} />;
    $[5] = IconComponent;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={t3}>{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
const StarRating = t0 => {
  const $ = _c(25);
  const {
    category,
    setRatings,
    ratings
  } = t0;
  const [rating, setRating] = useState(category.count);
  let t1;
  if ($[0] !== category || $[1] !== ratings || $[2] !== setRatings) {
    t1 = value => {
      const index = ratings.findIndex(item => item.tag === category.tag);
      const updatedRatings = [...ratings];
      updatedRatings[index] = {
        ...category,
        count: value
      };
      setRatings(updatedRatings);
      setRating(value);
    };
    $[0] = category;
    $[1] = ratings;
    $[2] = setRatings;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleRating = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      efficacy: "efficacy",
      safety: "safety",
      tolerability: "tolerability",
      adherence: "adherence",
      priceandaffordability: "price"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const iconMap = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      efficacy: "#EC4899",
      safety: "#3B82F6",
      tolerability: "#8B5CF6",
      adherence: "#8B5CF6",
      priceandaffordability: "#F59E0B"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const colorMap = t3;
  const t4 = iconMap[category.tag] || "efficacy";
  const t5 = colorMap[category.tag] || "#EC4899";
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <CategoryIcon icon={t4} color={t5} />;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== category.label) {
    t7 = <div className="text-sm sm:text-base font-semibold text-gray-900 font-poppins mb-0.5 sm:mb-1">{category.label}</div>;
    $[9] = category.label;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== category.description) {
    t8 = category.description && <div className="text-xs sm:text-sm text-gray-500 font-normal font-poppins mb-2 sm:mb-3 line-clamp-2">{category.description}</div>;
    $[11] = category.description;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [1, 2, 3, 4, 5];
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== category.tag || $[15] !== handleRating || $[16] !== rating) {
    t10 = <div className="flex gap-0.5 sm:gap-1">{t9.map(star => <button key={star} onClick={() => handleRating(star)} className="focus:outline-none transition-transform hover:scale-110">{star <= rating ? <RatingStar className="w-5 h-5 sm:w-6 sm:h-6" fill="#1E5EFF" clipId={`clip_${category.tag}_${star}`} /> : <OutlineStar className="w-5 h-5 sm:w-6 sm:h-6 text-gray-300" />}</button>)}</div>;
    $[14] = category.tag;
    $[15] = handleRating;
    $[16] = rating;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7 || $[20] !== t8) {
    t11 = <div className="flex-1 min-w-0">{t7}{t8}{t10}</div>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t6) {
    t12 = <div className="flex items-start gap-2 sm:gap-4">{t6}{t11}</div>;
    $[22] = t11;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};
const ClinicalPerformance = t0 => {
  const $ = _c(30);
  const {
    clinicalRatings,
    setClinicalRatings,
    productName,
    selectedIndication,
    onBack,
    onNext
  } = t0;
  let t1;
  if ($[0] !== clinicalRatings) {
    t1 = clinicalRatings.every(_temp);
    $[0] = clinicalRatings;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isClinicalPerformanceComplete = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><FiActivity className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Clinical Performance</h2></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = productName || "this product";
  let t4;
  if ($[3] !== t3) {
    t4 = <span className="font-semibold">{t3}</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = selectedIndication || "this indication";
  let t6;
  if ($[5] !== t5) {
    t6 = <span className="font-semibold">{t5}</span>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t6) {
    t7 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-4 sm:mb-6">Rate the following based on your real-world experience with {t4} for {t6}:</p>;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== clinicalRatings || $[11] !== setClinicalRatings) {
    t8 = clinicalRatings.map(category => <div key={category.tag} className="bg-white rounded-lg p-3 sm:p-4 border border-gray-200"><StarRating category={category} setRatings={setClinicalRatings} ratings={clinicalRatings} /></div>);
    $[10] = clinicalRatings;
    $[11] = setClinicalRatings;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <div className="grid grid-cols-1 md:grid-cols-2 gap-2 sm:gap-3">{t8}</div>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t2}{t7}{t9}</div></div>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== onBack) {
    t11 = <button onClick={onBack} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors">Back</button>;
    $[18] = onBack;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = !isClinicalPerformanceComplete;
  const t13 = `flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all ${isClinicalPerformanceComplete ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]" : "bg-gray-300 cursor-not-allowed"}`;
  let t14;
  if ($[20] !== onNext || $[21] !== t12 || $[22] !== t13) {
    t14 = <button disabled={t12} onClick={onNext} className={t13}>Next</button>;
    $[20] = onNext;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t11 || $[25] !== t14) {
    t15 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex gap-2 sm:gap-3 flex-shrink-0">{t11}{t14}</div>;
    $[24] = t11;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t10 || $[28] !== t15) {
    t16 = <>{t10}{t15}</>;
    $[27] = t10;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
};
export default ClinicalPerformance;
function _temp(rating) {
  return rating.count > 0;
}